<template>
  <div class="app-main">
    <el-container>
      <el-aside width="100px">
        <Menubox ref="menu"></Menubox>
      </el-aside>
      <el-main class="contents">
        <router-view v-on:upList="upFn()"></router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import Menubox from './multiplex/menu.vue'
export default {
  name: "home",
  components: {
    Menubox
  },
  methods: {
    upFn(){
      this.$refs.menu.querylist()
    }
  }
};
</script>
<style scoped lang="scss">
.app-main {
  min-width: 750px;
  background: #f5f5f5;
  height: 100vh;
  display: flex;
  overflow-y: hidden;
}
.home-box {
  .main-box {
    height: calc(100% - 80px);
    display: flex;
    .left-box {
      width: 200px;
      height: 100%;
      border-right: solid 1px #e6e6e6;
      background-color: #fff;
      .el-menu {
        border-right: unset;
        background-color: unset;
      }
    }
    .right-box {
      flex: 1;
      height: 100%;
      overflow: auto;
    }
  }

}
::v-deep .el-row {
    margin-right: 0 !important;
  }
.contents{
  overflow-y: auto;
  width: calc(100% - 100px);
  height: 100%;
  overflow-x: hidden;
}
 ::v-deep .el-header{
  height: 0px;
  background: white;
}
::v-deep .el-dialog__header{
  border: solid 1px #eee!important;
}
::v-deep .el-main{
  padding: 0px !important;
  padding-left: 5px !important;
}
::v-deep .el-header{
  background: #409EFF;
}
::v-deep .el-table::before{
  display: none !important;
}
</style>
